export enum CouponDiscountType {
    Value = 1,
    Percentage = 2,
}

export enum CouponType
{
    SingleUse = 1,
    Vanity = 2,
}